import axios from "axios";
import { getLocale } from '../i18n';

axios.defaults.headers.common['Accept-Language'] = getLocale();

export default axios;